export default {
  OPTIONAL: 'Opcional',
  MANDATORY: 'Obligatorio',
  PENDING: 'Pendiente',
}
